import { RiCloseLine } from 'react-icons/ri';

import ToastVariant from '@lib/core/src/enums/ToastVariant';
import palette from '@lib/core/src/theme/palette';
import { Typography, Stack, Button } from '@mui/material';
import { enqueueSnackbar, closeSnackbar } from 'notistack';

export const launchErrorToast = (title?: string, caption?: string) => {
  enqueueSnackbar({
    variant: 'custom',
    customProps: {
      title: title || 'An error occurred',
      caption: caption || 'Please try again later.',
      variant: ToastVariant.ERROR,
      cta: {
        onClick: () => {
          closeSnackbar();
        }
      }
    }
  });
};

export const launchSuccessToast = (caption?: string) => {
  enqueueSnackbar({
    variant: 'custom',
    anchorOrigin: { vertical: 'top', horizontal: 'center' },
    customProps: {
      sx: {
        borderRadius: '48px',
        backgroundColor: palette.black
      },
      caption: (
        <Typography color={palette.white} fontSize="14px" fontWeight={600}>
          {caption}
        </Typography>
      ),
      variant: ToastVariant.INFO,
      cta: {
        label: <RiCloseLine color={palette.white} size={14} />,
        onClick: () => {
          closeSnackbar();
        }
      }
    }
  });
};

interface ActionToastProps {
  caption: string;
  action?: {
    label: string;
    onClick: () => void;
  };
  vertical?: 'top' | 'bottom';
  horizontal?: 'left' | 'center' | 'right';
}

export const actionToast = ({
  caption,
  action,
  vertical = 'top',
  horizontal = 'center'
}: ActionToastProps) => {
  enqueueSnackbar({
    variant: 'custom',
    anchorOrigin: { vertical, horizontal },
    customProps: {
      sx: {
        borderRadius: '48px',
        backgroundColor: palette.black
      },
      caption: (
        <Stack direction="row" spacing={2} alignItems="center">
          <Typography color={palette.white} fontSize="14px">
            {caption}
          </Typography>
          {action && (
            <Button
              sx={{
                cursor: 'pointer',
                color: palette.black,
                fontSize: '14px',
                textTransform: 'none',
                backgroundColor: palette.white,
                borderRadius: '48px',
                padding: '4px 8px'
              }}
              onClick={() => {
                action.onClick();
                closeSnackbar();
              }}
            >
              {action.label}
            </Button>
          )}
        </Stack>
      ),
      variant: ToastVariant.INFO,
      cta: {
        label: <RiCloseLine color={palette.white} size={14} />,
        onClick: () => {
          closeSnackbar();
        }
      }
    }
  });
};
